export const CLEAR_APPLICATION_STATE = 'petdata/CLEAR_APPLICATION_STATE';


/** WEBPACK FOOTER **
 ** ./src/modules/common/actionTypes.js
 **/